/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { InvoiceTaskProperties } from './InvoiceTaskProperties';

export type InvoiceTask = {
    uuid: string;
    assignee?: number;
    update_time?: string;
    task_type: InvoiceTask.task_type;
    status: InvoiceTask.status;
    properties?: InvoiceTaskProperties;
};

export namespace InvoiceTask {

    export enum task_type {
        INVOICE = 'invoice',
    }

    export enum status {
        PREPARE_INVOICE = 'prepare_invoice',
        AWAITING_UNITS = 'awaiting_units',
        INVOICE_SENT = 'invoice_sent',
        IN_DISPUTE = 'in_dispute',
        TRANSACTION_PREPARED = 'transaction_prepared',
        COMPLETE = 'complete',
    }


}

